import type { ReactNode } from "react";
import { isTextNode } from "../../utils/reactNode";
import { Text, defaultTextVariants } from "../Text";

/**
 * DataTable·DataGridView 의 빈·대기·실패 자리.
 *
 * 글자는 c6 가 `.empty` 문단으로 그린다(가운데 정렬·여백·muted 색). 요소 노드는 문단·여백·면 없이
 * `.emptySlot` 블록에 그대로 둔다 — 노드는 div·button 을 품을 수 있어 문단 안에 두면 HTML 이 깨지고,
 * 자기 면·여백을 가진 노드(빈 상태 안내 + 동작 버튼)에 c6 여백이 겹쳐 쌓인다. 배치는 노드가 소유한다.
 *
 * `leading` 은 글자 앞에 놓는 c6 표시다(대기 스피너). 노드에는 붙이지 않는다. 노드가 자기 표시를 갖는다.
 */
export function CollectionMessage({
  children,
  leading,
}: {
  children: ReactNode;
  leading?: ReactNode;
}): ReactNode {
  return isTextNode(children) ? (
    <Text variant={defaultTextVariants["body-normal"]} className="empty">
      {leading}
      {children}
    </Text>
  ) : (
    <div className="emptySlot">{children}</div>
  );
}
